import { browserSupportStorage } from './browser-storage-utils';

const tabID = Math.random();
const TAB_ID_LIST = 'tvx:instanceCount:idList';
const REGISTRATION_EXPIRATION_MS = 1000 * 10;
const REGISTRATION_RENEWAL_INTERVAL = 1000 * 3;

const getRegistrations = () => {
    return JSON.parse(localStorage.getItem(TAB_ID_LIST)) || [];
};

const saveRegistrations = (registrations) => {
    localStorage.setItem(TAB_ID_LIST, JSON.stringify(registrations));
};

// Purge expired IDs. Sometimes "unload" is not called when the page closes.
// May happen when browser (or entire computer) quits unexpectedly.
(() => {
    if (!browserSupportStorage()) {
        return;
    }

    const registrations = getRegistrations();
    const filtered = registrations.filter((e) => {
        return (
            e.timeStamp &&
            new Date().getTime() - e.timeStamp < REGISTRATION_EXPIRATION_MS
        );
    });
    saveRegistrations(filtered);
})();

const updateRegistration = () => {
    const registrations = getRegistrations();
    const registration = registrations.find((e) => e.tabID === tabID);

    if (registration) {
        registration.timeStamp = new Date().getTime();
        saveRegistrations(registrations);
        setTimeout(updateRegistration, REGISTRATION_RENEWAL_INTERVAL);
    }
};

export const registerInstance = () => {
    if (!browserSupportStorage()) {
        return;
    }

    const registrations = getRegistrations();

    // Don't register again if the tab is already registered.
    if (registrations.find((e) => e.tabID === tabID)) {
        return;
    }

    registrations.push({ tabID, timeStamp: new Date().getTime() });
    saveRegistrations(registrations);
    updateRegistration();
};

export const unregisterInstance = () => {
    if (!browserSupportStorage()) {
        return;
    }

    const registrations = getRegistrations();
    const filtered = registrations.filter((e) => {
        return e.tabID !== tabID;
    });
    saveRegistrations(filtered);
};

export const isTheOnlyRegistration = () => {
    if (!browserSupportStorage()) {
        return true;
    }

    const registrations = getRegistrations();
    if (registrations.length === 0) {
        return true;
    } else if (registrations.length === 1) {
        return getRegistrations()[0].tabID === tabID;
    }
    return false;
};

const getMainRegistration = () => {
    const registrations = getRegistrations();
    if (registrations.length === 0) {
        throw new Error('No registered CTI instances');
    }
    return registrations[registrations.length - 1];
};

export const isMainRegistration = () => {
    return getMainRegistration().tabID === tabID;
};

export const setMainRegistration = () => {
    const registrations = getRegistrations();
    const myInstanceIndex = registrations.findIndex(
        (instance) => instance.tabID === tabID,
    );

    if (myInstanceIndex === -1) {
        throw new Error('This CTI instance is not registered');
    }

    const myInstance = registrations.splice(myInstanceIndex, 1);
    registrations.push(...myInstance);

    saveRegistrations(registrations);
};

window.addEventListener('unload', unregisterInstance);
